import useFetch from "../../../../hooks/useFetch"
import {SelectInput, Spinner, Icon} from "asocomponents"
import EstadosJuicioService from "../../../../../modules/EstadosJuicio/application/EstadosJuicioService"

function SelectEstadoJuicio({onChange, width, todos, valor}) {
  const estadosJuiciosService = new EstadosJuicioService()
  const { isLoading, data, isFailed } = useFetch(
    estadosJuiciosService,
    "getEstadosJuicios",
  )

  if (isLoading) {
    return <Spinner color="red" size="10" />
  }

  if (isFailed) {
    return <Icon type="error"/>
  }

  return (
    <div>
      <SelectInput options={data} placeholder="Seleccionar" onChange={onChange} width={width} todos={todos && true} defaultValue={valor || "-2"}></SelectInput>
    </div>
  )
}

export default SelectEstadoJuicio

